import type { IconSvgObject } from './types';

const ChevronsLeftRightIcon: IconSvgObject = [
  ["path", { d: "M15 7L20 12L15 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 7L4 12L9 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsLeftRightIcon;
